import { FormControl, Input, InputLabel, MenuItem, Select, Theme } from '@mui/material';
import React from 'react';
import { createStyles, makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { CreditGroupItemDto, LeasingGroupItemDto } from '../../modelView';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 200,
      maxWidth: 400,
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
  }),
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 150,
    },
  },
};

export default function OptionsSelect(props: {
  item: CreditGroupItemDto | LeasingGroupItemDto;
  index: number;
  value: number | null;
  onChangeHandler: (
    item: CreditGroupItemDto | LeasingGroupItemDto,
    index: number,
    newValue: string | number | null,
  ) => void;
  options: number[] | undefined;
  fieldKey: string;
}) {
  const classes = useStyles();

  return (
    <FormControl
      className={classes.formControl}
      required
      error={props.value == undefined}
    >
      <Select
        id={`credit-group-item-select-${props.fieldKey}-${props.index}`}
        value={props.value}
        onChange={(event) => props.onChangeHandler(props.item, props.index, event.target.value)}
        input={<Input />}
        MenuProps={MenuProps}
      >
        {props.options?.map((limit: number) => (
          <MenuItem
            key={limit}
            value={limit}
          >
            {limit}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
